module.exports = __webpack_public_path__ + "static/media/04510010-dJSzwSgs.de7f4da6.JPG";